module.exports = __webpack_public_path__ + "static/media/banner3.e5faf19a.jpg";